/*
 * // Created on 2024-04-12
 * // Created by Vitaut Tryputsin
 * //
 * // Copyright (c) 2024 OPEN CASCADE SAS
 * //
 * // This file is part of commercial software by OPEN CASCADE SAS,
 * // furnished in accordance with the terms and conditions of the contract
 * // and with the inclusion of this copyright notice.
 * // This file or any part thereof may not be provided or otherwise
 * // made available to any third party.
 * //
 * // No ownership title to the software is transferred hereby.
 * //
 * // OPEN CASCADE SAS makes no representation or warranties with respect to the
 * // performance of this software, and specifically disclaims any responsibility
 * // for any damages, special or consequential, connected with its use.
 *
 */
/**
 * Convert a cpp vector to a typescript vector
 * @param theVector - cpp vector
 * @return typescript vector
 * @internal
 */
export function cppToTsVector(theVector) {
    const aRet = [];
    for (let i = 0; i < theVector.size(); i++) {
        aRet.push(theVector.get(i));
    }
    theVector.delete();
    return aRet;
}
/**
 * Convert a typescript vector to a cpp vector
 * @param theVector - typescript vector
 * @param theCppClass - cpp class
 * @return cpp vector
 * @internal
 */
export function tsToCppVector(theVector, theCppClass) {
    const aRet = new theCppClass();
    for (const aValue of theVector) {
        // @ts-ignore
        aRet.push_back(aValue);
    }
    return aRet;
}
